// extracted by mini-css-extract-plugin
export default {"title":"modalError_title__gZNs5","text":"modalError_text__+AvJv","button":"modalError_button__r2zqz"};